module.exports = __webpack_public_path__ + "img/采集过程.757130fd.png";